import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader-mod/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "true",
  "use": "true-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"true\"><defs><style></style></defs><path d=\"M994.305 166.16c-39.945-40.917-104.706-40.917-144.652 0L391.586 635.504 174.61 413.192c-39.946-40.936-104.706-40.936-144.643 0-39.956 40.918-39.956 107.283 0 148.214l289.296 296.42c39.946 40.936 104.7 40.936 144.647 0l530.395-543.451c39.947-40.927 39.947-107.283 0-148.215z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol